export default {
  previous: '< 上一步',
  next: '下一步 >',
  done: '完成',
};



/** WEBPACK FOOTER **
 ** ./src/locale/zh_CN.js
 **/